<template>
	<div style="width: 100%; text-align:left;  background-color: white !important;">
		<v-row align="center">
			<v-col cols="3">
				<v-img src="@/assets/ciclo-urbano.png" width="200px"></v-img>
			</v-col>
			<v-col cols="9" class="text-left overline">
				<div>
					UrbanPlagas SpA
				</div>
				<div>
					Diseño, mantención de areas verdes y manejo integral en control de plagas
				</div>
				<div>
					r.u.t 76.693.777-2
				</div>
				<div>Clorinda Henriquez 99, La reina, R.M.</div>
				<div>2 3217 22 11 / +56978901179</div>
				<a href="https://www.ciclourbano.cl" target="_blank" style="text-decoration: none">
					www.ciclourbano.cl
				</a>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Solicitado por: </span>
					<b :class="{ 'primary--text': hasInfo(order[9]) }">{{ order[9] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Correo: </span>
					<b :class="{ 'primary--text': hasInfo(order[order.length - 2]) }">{{
						order[order.length - 2]
					}}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Rut: </span>
					<b :class="{ 'primary--text': hasInfo(order[2]) }">{{ order[2] }}</b>
				</div>
				<div class="text-left" :class="{ 'primary--text': hasInfo(order[3]) }">
					<span class="body-2"> Dirección: </span
					><b :class="{ 'primary--text': hasInfo(order[3]) }">{{ order[3] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Comuna / Ciudad: </span
					><b :class="{ 'primary--text': hasInfo(order[4]) }">{{ order[4] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Autorizado por: </span>
					<b :class="{ 'primary--text': hasInfo(order[5]) }">{{ order[5] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Rut: </span>
					<b :class="{ 'primary--text': hasInfo(order[6]) }">{{ order[6] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Dirección: </span
					><b :class="{ 'primary--text': hasInfo(order[7]) }">{{ order[7] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Comuna / Ciudad: </span
					><b :class="{ 'primary--text': hasInfo(order[8]) }">{{ order[8] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Fecha: </span>
					<b :class="{ 'primary--text': hasInfo(order[1]) }">{{ order[1] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> N° orden de trabajo: </span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }">{{ order[0] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2">Dirección perimetral:</span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }" v-if="place.address">{{
						place.address
					}}</b>
					<b :class="{ 'primary--text': hasInfo(order[0]) }" v-else
						>No hay perimetro establecido</b
					>
				</div>

				<div class="text-left" v-for="(email, index) in place.email" :key="index">
					<span class="body-2">Correo:</span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }">{{ email }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Diseño y construcción</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Plano general: </span>
					<b :class="{ 'primary--text': hasInfo(order[11]) }">{{ order[11] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Plano de plantación: </span>
					<b :class="{ 'primary--text': hasInfo(order[12]) }">{{ order[12] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Imagen objetivo: </span>
					<b :class="{ 'primary--text': hasInfo(order[13]) }">{{ order[13] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Foto montaje: </span>
					<b :class="{ 'primary--text': hasInfo(order[14]) }">{{ order[14] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Plano de riego: </span>
					<b :class="{ 'primary--text': hasInfo(order[15]) }">{{ order[15] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2">
						Plano de corte y elevación:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[16]) }">{{ order[16] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[17]) }">{{ order[17] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Áreas verdes</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[18]) }">{{ order[18] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[19]) }">{{ order[19] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Corte de cesped: </span>
					<b :class="{ 'primary--text': hasInfo(order[20]) }">{{ order[20] }}</b>
				</div>
			</v-col>
			<v-col cols="12" sm="2">
				<div class="text-left">
					<span class="body-2"> Desmalezado industrial: </span>
					<b :class="{ 'primary--text': hasInfo(order[21]) }">{{ order[21] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Retiro de hojas: </span>
					<b :class="{ 'primary--text': hasInfo(order[22]) }">{{ order[22] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Desmalezado:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[23]) }">{{ order[23] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Mullido de macizos:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[24]) }">{{ order[24] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Reposición de plantas:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[25]) }">{{ order[25] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Aireación:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[26]) }">{{ order[26] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Limpieza de jardineras:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[27]) }">{{ order[27] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Transplante:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[28]) }">{{ order[28] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Retiro de desechos:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[29]) }">{{ order[29] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Otros {{ order[31] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[30]) }">{{ order[30] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[32]) }">{{ order[32] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Tala & poda de árboles/arbustos</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[33]) }">{{ order[33] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[34]) }">{{ order[34] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Tala de áboles: </span>
					<b :class="{ 'primary--text': hasInfo(order[35]) }">{{
						order[35] === 'Si' ? order[36] : order[35]
					}}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Limpieza de palmeras:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[37]) }">
						{{ order[37] === 'Si' ? order[43] : order[37] }}
					</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Despeje de ramas:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[38]) }">
						{{ order[38] === 'Si' ? order[39] : order[38] }}
					</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Poda de áboles:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[40]) }">
						{{ order[40] === 'Si' ? order[41] : order[40] }}
					</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Retiro de desechos:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[42]) }">
						{{ order[42] === 'Si' ? order[44] : order[42] }}
					</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[47]) }">{{ order[47] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Riego automático</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[48]) }">{{ order[48] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[49]) }">{{ order[49] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Reparación de riego: </span>
					<b :class="{ 'primary--text': hasInfo(order[50]) }">{{ order[50] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Modificación de riego:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[51]) }">{{ order[51] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Instalación de riego: </span>
					<b :class="{ 'primary--text': hasInfo(order[52]) }">{{ order[52] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Codos:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[53]) }">{{ order[53] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Programadores:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[54]) }">{{ order[54] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						MTS Cafierias:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[55]) }">{{ order[55] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Aspersores:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[56]) }">{{ order[56] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2">
						Bombas solonoides:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[57]) }">{{ order[57] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> {{ order[59] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[58]) }">{{ order[58] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> {{ order[61] }}: </span>
					<b :class="{ 'primary--text': hasInfo(order[60]) }">{{ order[60] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2">
						Observaciones:
					</span>
					<b :class="{ 'primary--text': hasInfo(order[62]) }">{{ order[62] }}</b>
				</div>
			</v-col>
			<v-col cols="12" class="pb-0">
				<div class="title">Control fitosanitario</div>
			</v-col>
			<v-col cols="12">
				<v-divider></v-divider>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Mantención: </span>
					<b :class="{ 'primary--text': hasInfo(order[63]) }">{{ order[63] }}</b>
				</div>
			</v-col>
			<v-col sm="2" cols="12">
				<div class="text-left">
					<span class="body-2"> Asistencia: </span>
					<b :class="{ 'primary--text': hasInfo(order[64]) }">{{ order[64] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2"> Control de plagas: </span>
					<b :class="{ 'primary--text': hasInfo(order[65]) }">{{ order[65] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[66]) }">{{ order[66] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[67]) }">{{ order[67] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[68]) }">{{ order[68] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2"> Control: </span>
					<b :class="{ 'primary--text': hasInfo(order[69]) }">{{ order[69] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[70]) }">{{ order[70] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[71]) }">{{ order[72] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[72]) }">{{ order[72] }}</b>
				</div>
			</v-col>
			<v-col cols="12">
				<div class="text-left">
					<span class="body-2"> Fertilización: </span>
					<b :class="{ 'primary--text': hasInfo(order[73]) }">{{ order[73] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[74]) }">{{ order[74] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[75]) }">{{ order[75] }}</b>
				</div>
			</v-col>
			<v-col sm="4" cols="12">
				<div class="text-left">
					<b :class="{ 'primary--text': hasInfo(order[76]) }">{{ order[76] }}</b>
				</div>
			</v-col>
			<v-col sm="6" cols="12">
				<div class="text-left">
					<span class="body-2"> Aplicacion de herbicidas: </span>
					<b :class="{ 'primary--text': hasInfo(order[77]) }">{{ order[77] }}</b>
				</div>
			</v-col>
			<v-col sm="6" cols="12">
				<div class="text-left">
					<span class="body-2"> Observaciones: </span>
					<b :class="{ 'primary--text': hasInfo(order[78]) }">{{ order[78] }}</b>
				</div>
			</v-col>
			<v-col cols="12" v-if="hasInfo(order[79])">
				OT autorizada con fotografía:
				<v-img
					lazy-src="@/assets/placeholder.png"
					:src="order[80]"
					max-height="200px"
					max-width="200px"
					style="border-radius: 15px;"
					alt="imagen de la orden"
				>
					<div class="bg caption text-right">
						{{ dateTime }}
					</div>
				</v-img>
			</v-col>
			<template v-if="images">
				<v-col cols="12">
					Antecedentes fotográficos:
				</v-col>
				<div v-for="(img, key) in images" :key="key" class="d-flex child-flex ">
					<v-img
						v-if="isToday(order[1], img.createAt)"
						lazy-src="@/assets/placeholder.png"
						:src="img.url"
						max-height="200px"
						max-width="200px"
						class="mr-1 mb-1"
						style="border-radius: 15px;"
						alt="imagen de la orden"
					>
						<div class="bg caption text-right" v-if="img.createdAt">
							{{ createAt(img.createdAt) }}
						</div>
					</v-img>
					<div
						class="mr-1 mb-1 pl-2 pt-2"
						style="border-radius: 15px; height: 100px; width: 200px; border: 1px solid black;"
						v-else
					>
						Existe una foto tomada: {{ createAt(img.createdAt) }}
					</div>
				</div>
			</template>
		</v-row>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	props: {
		workOrder: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			idLodging: undefined,
			indexWorkOrder: undefined,
			order: [],
			place: '',
			images: [],
		};
	},
	computed: {
		dateTime() {
			return moment(this.order[79]).format('lll');
		},
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	watch: {
		workOrder() {
			this.order = this.workOrder;
		},
	},
	created() {
		if (!this.$vuetify.breakpoint.lgAndUp)
			document.getElementById('viewport').setAttribute('content', 'width=900');
	},
	mounted() {
		this.idLodging = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;
		if (this.workOrder) {
			this.order = this.formatWorkOrder(this.workOrder);
			this.place = this.lodgingSelect.place;
			if (this.lodgingSelect.documents) {
				const documents = this.lodgingSelect.documents;
				this.images = documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			}
		} else if (this.idLodging && this.indexWorkOrder)
			this.getWorkOrder({
				idLodging: this.idLodging,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = this.formatWorkOrder(data.workOrder);
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			});
	},
	methods: {
		isToday(orderDate, datePhoto) {
			return moment(orderDate).isSame(datePhoto, 'day');
		},
		createAt(date) {
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},
		hasInfo(item) {
			return item !== 'Sin info';
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'Sin info';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
		}),
	},
};
</script>

<style scoped>
.bg {
	background-color: rgba(255, 255, 255, 0.5);
}
</style>
